import React from 'react';

const CodeExample = () => {
  return (
    <section className="py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="section-heading text-4xl md:text-5xl font-heading font-bold text-center mb-16 gradient-text">
          Clean, Intuitive API
        </h2>

        {/* Code editor container */}
        <div className="code-editor bg-primary-950 rounded-2xl overflow-hidden shadow-2xl border border-white/[0.08]">
          {/* Top bar */}
          <div className="px-6 py-4 border-b border-white/10 flex items-center gap-2">
            <span className="w-3 h-3 rounded-full bg-red-500"></span>
            <span className="w-3 h-3 rounded-full bg-yellow-500"></span>
            <span className="w-3 h-3 rounded-full bg-green-500"></span>
            <span className="ml-4 text-gray-400 text-sm font-mono">
              app.js
            </span>
          </div>

          {/* Code area */}
          <pre className="p-6 font-mono text-sm leading-relaxed overflow-x-auto">
            <code>
              <span className="text-purple-400">import</span>
              <span className="text-white"> sl </span>
              <span className="text-purple-400">from</span>
              <span className="text-green-400"> 'sl-address'</span>
              <span className="text-white">;</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Explore the hierarchy'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> provinces = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">getProvinces</span>
              <span className="text-white">();</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> westernDistricts = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">getDistrictsByProvince</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'Western'</span>
              <span className="text-white">);</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> colomboCities = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">getCitiesByDistrict</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'Colombo'</span>
              <span className="text-white">);</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Quick postal lookup'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> info = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">getInfoByPostal</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'10280'</span>
              <span className="text-white">);</span>
              {'\n'}
              <span className="text-blue-300">console</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">log</span>
              <span className="text-white">(</span>
              <span className="text-blue-300">info</span>
              <span className="text-white">);</span>
              {'\n'}
              <span className="text-gray-500">{"// → { city: 'Maharagama', district: 'Colombo',"}</span>
              {'\n'}
              <span className="text-gray-500">{"//    province: 'Western', postalCode: '10280' }"}</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Fuzzy search handles typos'}</span>
              {'\n'}
              <span className="text-purple-400">const</span>
              <span className="text-white"> results = </span>
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">searchCity</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'maha ragama'</span>
              <span className="text-white">);</span>
              {'\n'}
              <span className="text-blue-300">console</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">log</span>
              <span className="text-white">(</span>
              <span className="text-blue-300">results</span>
              <span className="text-white">[</span>
              <span className="text-orange-400">0</span>
              <span className="text-white">].</span>
              <span className="text-blue-300">city</span>
              <span className="text-white">);  </span>
              <span className="text-gray-500">{"// → 'Maharagama'"}</span>
              {'\n'}
              <span className="text-blue-300">console</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">log</span>
              <span className="text-white">(</span>
              <span className="text-blue-300">results</span>
              <span className="text-white">[</span>
              <span className="text-orange-400">0</span>
              <span className="text-white">].</span>
              <span className="text-blue-300">score</span>
              <span className="text-white">); </span>
              <span className="text-gray-500">{"// → 0.95"}</span>
              {'\n\n'}
              <span className="text-gray-500">{'// Normalize messy input'}</span>
              {'\n'}
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">normalize</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'MAHARAGAMA'</span>
              <span className="text-white">);  </span>
              <span className="text-gray-500">{"// → 'maharagama'"}</span>
              {'\n'}
              <span className="text-blue-300">sl</span>
              <span className="text-white">.</span>
              <span className="text-yellow-300">toReadable</span>
              <span className="text-white">(</span>
              <span className="text-green-400">'10280'</span>
              <span className="text-white">);      </span>
              <span className="text-gray-500">{"// → 'Maharagama, Colombo, Western'"}</span>
            </code>
          </pre>
        </div>
      </div>
    </section>
  );
};

export default CodeExample;
